import { Stack } from "@mui/material";
import useColumnEdited from "developer/edit/hooks/useColumnEdited";
import React from "react";
import AutoSave from "../autoSave";
import AppearenceSection from "./AppearenceSection";
import BehaviorSection from "./BehaviorSection";
import GeneralSection from "./GeneralSection";
import NameAndTypeSection from "./NameAndTypeSection";
import SelectOptionsSection from "./OptionsSection";
import PanelBreadcrumb from "./PanelBreadcrumb";
import TableColumnsSection from "./TableColumnsSection";
import ValidationExpressionsSection from "./ValidationExpressionsSection";
import ValidationSection from "./ValidationSection";

const VisualEditorPanelSections: React.FC = () => {
  const columnEdited = useColumnEdited();
  const showBreadcrumb = !!columnEdited;

  return (
    <Stack spacing={1}>
      {showBreadcrumb && <PanelBreadcrumb />}
      <NameAndTypeSection />
      <GeneralSection />
      <SelectOptionsSection />
      <TableColumnsSection />
      <AppearenceSection />
      <ValidationSection />
      <ValidationExpressionsSection />
      <BehaviorSection />
      <AutoSave />
    </Stack>
  );
};

export default VisualEditorPanelSections;
